/**
 * Created with IntelliJ IDEA.
 * User: liors
 * Date: 7/23/13
 * Time: 3:52 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var RevisionedModel = require("models/RevisionedModel");
    var NameUtility = require("utils/NameUtility");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var QuestionCollection = require("collections/entities/QuestionCollection");
    var Config = require("campaigns-assets/config/config.json");

    const lpUtils = require("utils/lpUtils");

    var OFFLINE_PROPS_PARAMS = {
        RECEIVER_NAME: 'receiverName',
        RECEIVER_EMAIL: 'receiverEmail',
        EMAIL_SUBJECT: 'subjectEmail',
        EMAIL_FOOTER: 'emailFooter',
        USE_SKILL_EMAIL: 'useSkillEmail'
    };

    var KEYS = {
        ID: "id",
        EXTERNALID: "externalId",
        QUESTIONS: "json.questions.surveyQuestion",
        HEADING: "json.heading",
        FOOTER: "json.footer",
        NAME: "name",
        INETERNALNAME: "json.name",
        TYPE: "type",
        SURVEY_TYPE_ENABLED: "surveyTypeEnabled",
        DEFAULT_SURVEY: "defaultSurvey",
        JSON: "json",
        LOGIC: "json.logic",
        SURVEY_EXTRA: "json.extraParams",
        SURVEY_PARAM: "json.extraParams.param",
        OFFLINE_SURVEY_RECEIVER_NAME: 'offlineProps.' + OFFLINE_PROPS_PARAMS.RECEIVER_NAME,
        OFFLINE_SURVEY_RECEIVER_EMAIL: 'offlineProps.' + OFFLINE_PROPS_PARAMS.RECEIVER_EMAIL,
        OFFLINE_SURVEY_EMAIL_SUBJECT: 'offlineProps.' + OFFLINE_PROPS_PARAMS.EMAIL_SUBJECT,
        OFFLINE_SURVEY_EMAIL_FOOTER: 'offlineProps.' + OFFLINE_PROPS_PARAMS.EMAIL_FOOTER
    };

    var VALUES = {
        TYPE: {
            "PRE_CHAT": "Pre-Chat",
            "POST_CHAT": "Exit",
            "OFFLINE": "Offline",
            "AGENT": "Chat Operator"
        }
    };

    var CSAT_PARAMS = {
        CSAT_KEY:"chat_customer_satisfaction_1",
        CSAT_DEFAULT_VALUE: 5
    };

    var SurveyModel = RevisionedModel.extend({
        resource: ApiResources.AccountConfig.Survey.Standard,
        TYPES: VALUES.TYPE,
        idAttribute: "externalId",
        name: "SurveyModel",

        defaults: {
            dateCreated: "",
            dateUpdated: "",
            deleted: false,
            externalId: "",
            id: -1,
            surveyTypeEnabled: false,
            json: {
                surveyTypeEnabled: false,
                dbid: -1,
                extraParams: null,
                heading: "",
                name: "",
                questions: {
                    surveyQuestion: [
                    ]
                },
                surveyType: ""
            },
            name: "",
            type: ""
        },

        parse: function (response, options) {
            if (response && response.type === VALUES.TYPE.OFFLINE) {
                var offlineProps = {};
                var extraParams = response.json && response.json.extraParams && response.json.extraParams.param;
                if (extraParams && Array.isArray(extraParams)) {
                    var offlinePropsRaw = _.find(extraParams, function (param) {
                        return param.name === 'offlineprops';
                    });
                    if (offlinePropsRaw && offlinePropsRaw.value) {
                        try {
                            var offlinePropsXML = $($.parseXML(offlinePropsRaw.value));
                            if (offlinePropsXML) {
                                Object.keys(OFFLINE_PROPS_PARAMS).forEach(function (key) {
                                    var attribute = offlinePropsXML.find(OFFLINE_PROPS_PARAMS[key]);
                                    if (attribute && attribute.length) {
                                        offlineProps[OFFLINE_PROPS_PARAMS[key]] = attribute.text();
                                    }
                                });
                            }
                            if (Object.keys(offlineProps).length > 0) {
                                response.offlineProps = offlineProps;
                            }
                        } catch (err) {
                            // TODO
                        }
                    }
                }
            }
            return RevisionedModel.prototype.parse.call(this, response, options);
        },

        toJSON: function () {
            var json = RevisionedModel.prototype.toJSON.apply(this, [].slice.apply(arguments));
            if (json.type === VALUES.TYPE.OFFLINE) {
                var newOfflinePropsRaw = '';
                if (json.offlineProps) {
                    if (typeof json.offlineProps[OFFLINE_PROPS_PARAMS.USE_SKILL_EMAIL] === 'undefined') {
                        json.offlineProps[OFFLINE_PROPS_PARAMS.USE_SKILL_EMAIL] = 'true';
                    }
                    var newOfflineProps = [];
                    Object.keys(json.offlineProps).forEach(function (key) {
                        if (json.offlineProps[key]) {
                            newOfflineProps.push('<' + key + '>' + lpUtils.encodeXML(json.offlineProps[key]) + '</' + key + '>');
                        }
                    });
                    if (newOfflineProps.length > 1) { // since useSkillEmail is always present and we don't want to save just that
                        newOfflinePropsRaw = '<data>' + newOfflineProps.join('') + '</data>';
                    }
                }


                var existingOfflineProps = _.find(json.json.extraParams && json.json.extraParams.param, function (param) {
                    return param.name === 'offlineprops';
                });
                if (existingOfflineProps) {
                    existingOfflineProps.value = newOfflinePropsRaw;
                } else {
                    json.json.extraParams = json.json.extraParams || {};
                    json.json.extraParams.param = json.json.extraParams.param || [];
                    json.json.extraParams.param.push({
                        name: 'offlineprops',
                        value: newOfflinePropsRaw
                    });
                }
            }
            delete json.offlineProps;
            return json;
        },

        fetch: function(options) {
            options = options ? _.clone(options) : {};
            var success = options.success;

            options.success = _.bind(function(model, resp, options) {
                this._initQuestionsCollection();

                if (success) {
                    success(model, resp, options);
                } //call original success function
            }, this);
            return RevisionedModel.prototype.fetch.call(this,options);
        },

        save: function(key, val, options) {
            this.pullInternalChangesToModel();
            return RevisionedModel.prototype.save.call(this, key, val, options);
        },

        pullInternalChangesToModel: function() {
            this.setSurveyQuestions(this.questions.toJSON());
        },
        _initQuestionsCollection: function() {
            this.questions = new QuestionCollection(this.getSurveyQuestions(), {
                // csatPositive: false, // value to define - not setting by default
                surveyType: this.get('type')
            });
        },

        /* private getter setter */
        _getValue: function (key) {
            return this.get(key);
        },
        _setValue: function (key, value) {
            if(this._getValue(key) !== value){
                this.set(key, value);
            }
        },

        validation: {
            "name": [
                {
                    fn: function (name) {
                        // validate if name exists
                        var result = this.surveyNameNotExist(name, this.getSurveyType(), this.isNew());
                        if (!result) {
                            return "LECampaigns.engagementWindow.survey.title.duplicateSurveyName.error";
                        }
                    }
                }
            ],
            "json.heading": [
                {
                    required: false,
                    maxLength: Config.validators.engagementWindowModel.maxSurveyHeading,
                    msg: "LECampaigns.engagementWindow.survey.heading.errors.length"
                }
            ],
            'offlineProps.receiverEmail': [{
                required: false,
                pattern: 'email',
                msg: 'LECampaigns.chatStudio.survey.settings.offline.email.setup.errors.email'
            }]
        },
        surveyNameNotExist: function (surveyName, type, isNew) {
            var allowedWithSameName = 1;
            var resultCollection = this.collection.filter(function (a) {
                return(a.attributes.name === surveyName);
            }).filter(function (a) {
                return(a.attributes.type === type);
            });
            return (resultCollection.length <= allowedWithSameName);
        },

        /* public getters setters */


        getSurveyId: function () {
            return this._getValue(KEYS.ID);
        },
        setSurveyId: function (id) {
            this._setValue(KEYS.ID, id);
        },
        getSurveyExternalId: function () {
            return this._getValue(KEYS.EXTERNALID);
        },
        setSurveyExternalId: function (id) {
            this._setValue(KEYS.EXTERNALID, id);
        },
        getSurveyQuestions: function () {
            return this._getValue(KEYS.QUESTIONS);
        },
        setSurveyQuestions: function (questions) {
            this._setValue(KEYS.QUESTIONS, questions);
        },
        getSurveyHeading: function () {
            return this._getValue(KEYS.HEADING);
        },
        setSurveyHeading: function (heading) {
             this._setValue(KEYS.HEADING, heading);
        },
        getSurveyFooter: function () {
            return this._getValue(KEYS.FOOTER);
        },
        setSurveyFooter: function (footer) {
             this._setValue(KEYS.FOOTER, footer);
        },
        getSurveyName: function () {
            return this._getValue(KEYS.NAME);
        },
        setSurveyName: function (name) {
            this._setValue(KEYS.NAME, name);
            this._setValue(KEYS.INETERNALNAME, name);
        },
        getSurveyType: function () {
            return this._getValue(KEYS.TYPE);
        },
        getSurveyExtra: function () {
            return this._getValue(KEYS.SURVEY_EXTRA);
        },
        getSurveyExtraParameters: function () {
            return this._getValue(KEYS.SURVEY_PARAM);
        },
        setSurveyType: function (type) {
            this._setValue(KEYS.TYPE, type);
        },
        getSurveyTypeEnabled: function () {
            return this._getValue(KEYS.SURVEY_TYPE_ENABLED);
        },
        setSurveyTypeEnabled: function (enabled) {
            this._setValue("surveyTypeEnabled", enabled);
            this._setValue("json.surveyTypeEnabled", enabled);
        },
        setDefaultSurvey: function (enabled) {
            if (enabled) {
                this._setValue("defaultSurvey", enabled);
                this._setValue("json.defaultSurvey", enabled + "");
            } else{
                this.unset("defaultSurvey");    //on survey creation default survey must be removed ( cant be false)
                this.unset("json.defaultSurvey");
            }
            this.trigger("change:default");
        },
        isDefaultSurvey: function(){
            return !!this.get(KEYS.DEFAULT_SURVEY) ;
        },
        getSurveyJson: function(){
            return this.get(KEYS.JSON);
        },
        hasLogic: function(){
           return !_.isEmpty(this.get(KEYS.LOGIC));
        },

        getOfflineSurveyReceiverName: function () {
            return this._getValue(KEYS.OFFLINE_SURVEY_RECEIVER_NAME);
        },

        setOfflineSurveyReceiverName: function (name) {
            this._setValue(KEYS.OFFLINE_SURVEY_RECEIVER_NAME, name);
        },

        getOfflineSurveyReceiverEmail: function () {
            return this._getValue(KEYS.OFFLINE_SURVEY_RECEIVER_EMAIL);
        },

        setOfflineSurveyReceiverEmail: function (email) {
            this._setValue(KEYS.OFFLINE_SURVEY_RECEIVER_EMAIL, email);
        },

        getOfflineSurveyEmailSubject: function () {
            return this._getValue(KEYS.OFFLINE_SURVEY_EMAIL_SUBJECT);
        },

        setOfflineSurveyEmailSubject: function (subject) {
            this._setValue(KEYS.OFFLINE_SURVEY_EMAIL_SUBJECT, subject);
        },

        getOfflineSurveyEmailFooter: function () {
            return this._getValue(KEYS.OFFLINE_SURVEY_EMAIL_FOOTER);
        },

        setOfflineSurveyEmailFooter: function (footer) {
            this._setValue(KEYS.OFFLINE_SURVEY_EMAIL_FOOTER, footer);
        },

        //it's a special case for the template saving.
        isNew: function () {
            return (this.id === undefined || this.id === -1 || this.id === "") && (this.externalId === undefined || this.externalId === "");
        },
        //model configuration
        isEditable: function() {
            return !this.hasLogic() && !this.isLastFetchReturnedError();
        },
        isViewable: function() {
            return !this.hasLogic() && !this.isLastFetchReturnedError();
        },
        isDeletable: function() {
            return !this.hasLogic() && !this.isLastFetchReturnedError();
        },
        isNewQuestionAllowed: function() {
            // can be overridden if only the template question are required.
            return true;
        },
        isFooterSupported: function() {
            // can be overridden if footer is supported by resource.
            return false;
        },
        isFooterEditable: function() {
            // can be overridden if footer is editable by resource.
            return false;
        },

        //-----------------------------------------------------------
        // setUniqueName
        //-----------------------------------------------------------

        setUniqueName:function(){
            this.setSurveyName(NameUtility.getUniqueName(this.collection, window.LE.translator.translate("LECampaigns.engagementWindow.survey.new.header")));
        },

        //-----------------------------------------------------------
        // cloneMe
        //-----------------------------------------------------------

        cloneMe:function(){
            var copy = this.clone();

            copy.resource = this.resource;
            copy.collection = this.collection;
            copy._initQuestionsCollection();
            return copy;
        },

        //-----------------------------------------------------------
        // getTemplate
        //-----------------------------------------------------------

        getTemplate: function (options) {

            var originalOptions = options || {};
            var originalResource = this.resource;

            this.resource = LEResourceResolver.getUrl(LEResourceResolver.apiResources.AccountConfig.Survey.Template);
            this.fetch({
                data: originalOptions.data,

                success: _.bind(function (model, resp, options) {

                    this.resource = originalResource;
                    this.collection = originalOptions.collection;

                    this.setUniqueName();
                    this.setSurveyTypeEnabled(false);
                    this.setDefaultSurvey(false);

                    if (originalOptions.success) {
                        originalOptions.success(model, resp, options);
                    }

                }, this),

                error: _.bind(function (model, resp, options) {
                    if (options.error) {
                        options.error(model, resp, options);
                    }
                }, this)
            });
            this.resource = originalResource;
        },


        //-----------------------------------------------------------
        // hasChangedSinceLastFetch
        //-----------------------------------------------------------
        /**
         * Return true if the model has been changed in the client, by checking
         * the current attributes against the attributes saved in the last fetch.
         */
        hasChangedSinceLastFetch: function () {
           return true;
           //todo this is an optimization function to be implemented if we have time
           //and only with UnitTests
        },

        setCsatDefaultPositive: function(){
           this.setCSATPositiveForExtraParams(CSAT_PARAMS.CSAT_DEFAULT_VALUE);
        },

        /**
         * parses survey's extraParams to fetch the positive value for the post-chat survey csat question
         * @returns {number}
         * @private
         */
        getCSATPositiveFromExtraParams: function(){
            if(this.getSurveyType() !== 'Exit'){
                return;
            }

            var value= 5;   //default positive value

            //fetch positive value from extra params
            var extra= this.getSurveyExtraParameters();
            if(!_.isEmpty(extra)){
                var positive= extra.filter(function(i) {
                    return i.name === CSAT_PARAMS.CSAT_KEY;
                })[0];
                if (positive) {
                    value= positive.value;
                }else {
                    this.setCSATPositiveForExtraParams(CSAT_PARAMS.CSAT_DEFAULT_VALUE); //apply defaults
                }
            }else{
                this.setCSATPositiveForExtraParams(CSAT_PARAMS.CSAT_DEFAULT_VALUE); //apply defaults
            }

            return value;
        },
        /**
         * modifies the extraParams according to value received
         * @param positive
         * @private
         */
        setCSATPositiveForExtraParams: function(positive){
            //for collection render to use the latest updated positive value.
            if(this.questions && positive){
                this.questions.csatPositive= positive;
            }

            var param,
                extra= this.getSurveyExtra();
            if(extra){
                param= this.getSurveyExtraParameters();
                if(_.isArray(param)){
                    var csatx= _.find(param, function(i) {
                        return i.name === CSAT_PARAMS.CSAT_KEY;
                    });
                    if(csatx){
                        csatx.value= positive || CSAT_PARAMS.CSAT_DEFAULT_VALUE;
                        return;
                    }
                }else{
                    extra.param= [];
                }
            }else{
                extra= this.getSurveyJson().extraParams= { "param": [] };
            }
            extra.param.push({name: CSAT_PARAMS.CSAT_KEY, value: positive});
        }
    });

    SurveyModel.KEYS = KEYS;

    SurveyModel.VALUES = VALUES;

    return SurveyModel;
});
